export default __webpack_public_path__ + "static/media/mag7.c0bb1db9.png";